import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";

import { CellKit, PaginatedResult } from "src/common/types";
import { useKy, HTTPError } from "src/common/ky";

export const CELL_KITS_QUERY_KEY = "CELL_KITS";
export const useCellKitsQuery = () => {
  const ky = useKy();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  if (!searchParams.has("pageNumber")) {
    searchParams.set("pageNumber", "1");
  }

  return useQuery<PaginatedResult<CellKit>>(
    [CELL_KITS_QUERY_KEY, searchParams.toString()],
    () => ky.get("cell-kits", { searchParams }).json<PaginatedResult<CellKit>>()
  );
};

export const getCellKitQueryKey = (id: string) => ["CELL_KIT", id];
export const useCellKitQuery = (cellKitId: string) => {
  const ky = useKy();
  return useQuery<CellKit, HTTPError>(
    getCellKitQueryKey(cellKitId),
    () => ky.get(`cell-kits/${cellKitId}`).json<CellKit>(),
    { staleTime: 60 * 1000 }
  );
};
